/**
 * Author: Qian.qianchen 2018-11-13
 * discription: 产品管理 微博 微博账号编辑
 */
"use strict";
angular.module("productManageMentEditQiehaoModule", [])
    .controller('productManageMentEditQiehaoCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation) {
        initStatus();

        function initStatus() {

            $scope.data = {
                currUser: {
                    accountName: item.ACCOUNTNAME,
                    ObjectId: item.KUAIBAOACCOUNTID,
                    ClientID: item.CLIENTID,
                    ClientSERCRET: item.CLIENTSERCRET,
                    isActive: item.ISACTIVE,
                    serviceid: 'mlf_kuaibaoaccount',
                    methodname: "save",
                }
            }
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.data.currUser, 'post', true).then(function(data) {
                $modalInstance.close({result: true});
            }, function(data) {
                $modalInstance.close({result: false, data:data});
            });
        };
    }]);